import { render, staticRenderFns } from "./LeadsTransferList.vue?vue&type=template&id=0fe54d48&scoped=true"
import script from "./LeadsTransferList.vue?vue&type=script&lang=js"
export * from "./LeadsTransferList.vue?vue&type=script&lang=js"
import style0 from "./LeadsTransferList.vue?vue&type=style&index=0&id=0fe54d48&prod&lang=scss&scoped=true"
import style1 from "./LeadsTransferList.vue?vue&type=style&index=1&id=0fe54d48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe54d48",
  null
  
)

export default component.exports